import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { QueryClientProvider } from "@tanstack/react-query"
import "@amzn/meridian-tokens/base/font/amazon-ember.css"
import App from "./App"
import ErrorBoundary from "./components/ErrorBoundary"
import { createQueryClient } from "./services/queryClient"
import "./index.css"

const queryClient = createQueryClient()

const rootElement = document.getElementById("root")
if (!rootElement) {
  throw new Error('Root element "#root" not found — index.html is missing the mount node.')
}

// Top-level ErrorBoundary wraps the providers so a failure in the router or
// query client still renders a fallback instead of a blank screen.
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
)
